import { BlogService } from 'src/app/data/repository/blog-repository/blog.service';
import { BlogShared } from './../../general/shared/blog-shared';
import { BlogUserService } from './../../../data/repository/blog-repository/blog-user.service';
import { BlogUserModel } from './../../../core/model/object/blog-user-model';
import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { User } from 'src/app/core/model/user-model';
import { Subscription } from 'rxjs';
import { SettingService } from 'src/app/data/repository/setting-repository/setting.service';
import { UserDataService } from 'src/app/data/repository/user-repository/user-data.service';
import { BottomsheetShared } from '../../general/shared/bottomsheet-shared';
import { BlogApiService } from 'src/app/data/repository/blog-repository/blog-api.service';

@Component({
  selector: 'app-tribune-setting',
  templateUrl: './tribune-setting.component.html',
  styleUrls: ['./tribune-setting.component.scss'],
})
export class TribuneSettingComponent implements OnInit, OnDestroy {
  id = 5;
  selectedUsername = '';
  profileId = 10;
  showProfile = false;

  showLoading = false;

  showEdit = false;
  selectedType: string;
  user: User;
  blogUser: BlogUserModel;

  profileTitles = ['وضعیت صفحه', 'حساب‌های کاربری مسدود شده'];
  profileValues = ['', ''];

  subscription1: Subscription;
  subscription2: Subscription;
  subscription3: Subscription;

  constructor(
    private settingService: SettingService,
    private userDataService: UserDataService,
    private bottomsheetShared: BottomsheetShared,
    private blogUserService: BlogUserService,
    private blogShared: BlogShared,
    private blogService: BlogService,
    private blogApiService: BlogApiService
  ) {
    this.subscription1 = this.bottomsheetShared.closeBottomsheetObs$.subscribe(
      (close) => {
        if (close) {
          this.showEdit = false;
          this.settingService.closeBottomSheet.next({ show: false });
        }
      }
    );

    this.subscription2 =
      this.bottomsheetShared.closeAndUpdateBottomsheetObs$.subscribe(
        (close) => {
          if (close) {
            this.prepare();
            this.showEdit = false;
            this.settingService.closeBottomSheet.next({ show: false });
          }
        }
      );
    this.subscription3 = this.blogShared.openProfileObs$.subscribe((open) => {
      if (open) {
        this.profile(this.blogShared.getSelectedUsername());
      }
    });

    this.prepare();
  }

  ngOnInit() {}

  @HostListener('window:beforeunload')
  ngOnDestroy(): void {
    this.subscription1.unsubscribe();
    this.subscription2.unsubscribe();
    this.subscription3.unsubscribe();
  }

  back() {
    this.settingService.goBack();
  }

  async prepare() {
    this.showLoading = true;
    if (
      !localStorage.getItem('blog-user') ||
      !localStorage.getItem('blog-token')
    ) {
      await this.blogApiService.getBlogUser(true);
    }
    this.userDataService.getUser().then((result) => {
      if (result) {
        this.user = result;
        this.profileValues[0] = result.name;
        this.blogUserService.getBlogUser().then((res) => {
          this.blogUser = res;
          this.profileValues[0] = res.status === 'public' ? 'عمومی' : 'خصوصی';
          this.profileValues[1] = '';

          this.showLoading = false;
        });
      }
    });
  }

  openEdit(index: number) {
    switch (index) {
      case 0:
        this.selectedType = 'isPublic';
        break;
      case 1:
        this.selectedType = 'blocks';
        break;
    }
    this.showEdit = true;
    this.settingService.bottomSheet.next({
      show: this.showEdit,
      data: {
        selected: this.selectedType,
        blogUser: this.blogUser,
        user: this.user,
      },
    });
  }

  profile(username: string) {
    this.blogService.goToUserProfile(username);
    // this.selectedUsername = username;
    // this.blogShared.blogZIndex++;
    // this.profileId = this.blogShared.blogZIndex;
    // this.showProfile = true;
    // setTimeout(() => {
    //   document.getElementById('profilePage' + this.id).style.zIndex =
    //     this.blogShared.blogZIndex.toString();
    //   document.getElementById('profilePage' + this.id).style.right = '0';
    // }, 100);
  }

  closeProfile() {
    this.blogShared.blogZIndex--;
    document.getElementById('profilePage' + this.id).style.right = '100%';
    // this._sharedService.animateDownButton();
    setTimeout(() => {
      this.showProfile = false;
    }, 300);
  }
}
